module.exports = __webpack_public_path__ + "static/mixer-ead72293100060be182801c9747d1259.png";